import shallow from 'zustand/shallow';

import Paywall from '../Paywall';
import useStore from '../store';

import { WidgetWrapper } from '../styled';

interface WidgetProps {
  height: string;
  source: string;
}

function PaywallWidget({ height, source }: WidgetProps) {
  const { isLoading, isRenewal } = useStore(
    ({ widget }) => ({
      isLoading: widget.isLoading,
      isRenewal: widget.isRenewal,
    }),
    shallow,
  );

  return (
    <WidgetWrapper height={height}>
      {!isLoading && (
        <Paywall source={source} isRenewal={isRenewal} height="100%" isWidget />
      )}
    </WidgetWrapper>
  );
}

export default PaywallWidget;
